<!--  保密局项目顶部 -->
<template>
<div class="cm_top_container">
  <img src="@/assets/img/index-top-bg.png" class="cm_top_bd">
  <div :class="mobileClass('cm_top_box')">
    <div class="cm_top_weather">
       <span v-if="date.length>0">{{date[0]}}年{{date[1]}}月{{date[2]}}日</span>
      <span v-if="weather">{{weather.text}}</span>
      <span v-if="weather">{{weather.temp}}℃</span>
      <span v-if="weather">{{weather.windDir}}</span>
    </div>
    <div :class="mobileClass('cm_top_logo_box')">
      <img src="@/assets/img/logo.png" alt="">
      <div :class="mobileClass('cm_top_logo_right')">
        <Search />
        <img src="@/assets/img/slogan.png" alt="">
      </div>
    </div>
    <div></div>
  </div>
  <Nav  class="cm_top_nav"/>
</div>
</template>

<script>
  import Search from '@/components/common/Search';
  import Nav from '@/components/nav/Navigation';

export default {
components: {Search,Nav},
data() {
//这里存放数据
return {
  weather:"",
  date:[],
  navList:this.$store.state.comData.navList,
  webData:[],
  windowWidth:document.documentElement.clientWidth
};
},
//监听属性 类似于data概念
computed: {
  mobileClass(){
       return (val)=>{
         if(this.windowWidth > 500) {
          return val
          } else {
            return "mobile_"+val
          }
       }
    },
  cutDate:function(dateStr){
    return dateStr.split("T")[0]
  }
},
//监控data中的数据变化
watch: {
  '$store.state.screenWidth': function (val) { //监听屏幕宽度变化
    this.windowWidth = val;
  }
},
//方法集合
methods: {
httpPost() {
      this.$http({
        url: "https://devapi.qweather.com/v7/weather/now?location=101080101&key=b00571a615ad47628513989afa3a71d4",
        method: 'get',
        data: {}
      }).then(({ data }) => {
        if(data.now!=""&&data.now!=undefined&&data.now!=null){
          this.weather = data.now
           this.date = this.weather.obsTime.split("T")[0].split("-")
          console.log(this.date)
        }
          
      });
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
  this.httpPost()
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  
},

}
</script>
<style scoped>
  .cm_top_nav{
    width:100%;
  }

.cm_top_weather{
  float: right;
  margin-top: 10px;
  color: #fff;
}
.cm_top_weather>span{
  margin-right: 10px;
}
.cm_top_container{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-wrap: wrap;
  /* background: url("../../assets/img/index-top-bg.png") */
}
.cm_top_box{
  width: 1200px;
  height: 200px;
}

.cm_top_bd{
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  /* box-sizing: border-box; */
}
.cm_top_logo_box{
  margin-top: 40px;
  display: flex;
  width: 100%;
  height: 150px;
  align-items: center;
  justify-content: space-between;
}
.cm_top_logo_right{
  width: 40%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.cm_top_logo_right>img{
  margin-top:20px;
}

/** 手机适配 */
.mobile_cm_top_box{
  width: 80%;
  height: 200px;
  display: flex;
  flex-wrap: wrap;

}
.mobile_cm_top_logo_box{
  margin-top: 10px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.mobile_cm_top_logo_box>img{
  width: 80%;
}
.mobile_cm_top_logo_right{
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-bottom: 20px;
}
.mobile_cm_top_logo_right>img{
  width: 0;
  height: 0;
}

</style>